<div class="loading_wrp"
    style="top: 0px; position: fixed; left: 0px; border-radius: 0px; background-color: rgb(221, 221, 221); opacity: 0.5;">
    <img src="/assets/images/loader-new.svg">
</div>